/* tslint:disable:max-line-length */
export const L10N_CS = {
  format_date: 'D.M.YYYY',
  format_date_placeholder: 'den.měsíc.rok',

  validation_required: 'Vyplňte prosím políčko {0}.',
  validation_requiredThis: 'Vyplňte prosím toto políčko.',
  validation_email: 'Hodnota políčka {0} není platným emailem.',
  validation_date: 'Hodnota není platným datumem. Platný formát: 15.2.1984',
  validation_captchaRequired: 'Klikněte prosím do bílého čtverečku. Kontrola slouží pro odfiltrování softvérových robotů.',
  validation_captchaInvalid: 'Neodepsali jste správně text z obrázku. Zkuste to znovu prosím.',
  validation_duplicateRegistration: 'Na vybraný program jste již přihlášen. Vyberte si prosím jiný.',
  validation_birthdateYear: 'Zadejte prosím platný rok narození',

  app_error_entityValidation: 'Ukládaná data nepřešla validací.',
  app_error_entityNotFound: 'Požadovaný záznam nebyl nalezen.',
  app_error_db_insertFailed: 'Při vkládání dat do databáze nastala chyba.',
  app_error_db_updateFailed: 'Při aktualizaci dat v databáze nastala chyba.',
  app_error_db_deleteFailed: 'Při mazání záznamu z databáze nastala chyba. Asi se na něj odkazují jiné záznamy.',
  app_error_internalServerError: 'Při zpracovávání požadavku nastala chyba.',

  app_page_title: 'Přihlašování na programy',

  error_otEventRegistrationDisabled: 'Omlouváme se, ale na tento program se nedá přihlašovat.',
  error_otEventIsFull: 'Omlouváme se, tento program je již zaplněn a nedá se naň přihlašovat.',

  warning: 'Upozornění',
  error: 'Chyba',

  menu_otEvents: 'Jednorázové akce',
  menu_price: 'Cena',
  menu_person: 'Osoba',
  menu_locations: 'Místa',
  menu_summary: 'Souhrn',
  menu_success: 'Přihláška vytvořena',

  dayOfWeek_0: 'Pondělí',
  dayOfWeek_1: 'Úterý',
  dayOfWeek_2: 'Středa',
  dayOfWeek_3: 'Čtvrtek',
  dayOfWeek_4: 'Pátek',
  dayOfWeek_5: 'Sobota',
  dayOfWeek_6: 'Neděle',

  region_entity: 'Región',

  person_lastName: 'Příjmení',
  person_firstName: 'Jméno',
  person_fullName: 'Jméno',
  person_birthdate: 'Datum narození',
  person_birthdateYear: 'Rok narození',
  person_email: 'Email',
  person_telephone: 'Telefon',
  person_street: 'Ulice a číslo',
  person_city: 'Město',
  person_zipCode: 'PSČ',
  person_country: 'Stát',
  person_address: 'Adresa',

  personAddress_showFields: 'Chci vyplnit svou adresu',
  personAddress_street: 'Ulice',
  personAddress_city: 'Město',
  personAddress_postcode: 'PSČ',
  personAddress_country: 'Stát',

  course_dayOfWeek: 'Den',
  course_timeFromTo: 'Čas',
  course_courseTags: 'Typ kurzu',
  course_description: 'Popis',
  course_venue: 'Místo konání',
  course_room: 'Místnost',
  course_teacher: 'Cvičitel',
  course_price: 'Cena',
  course_: '',
  course_organization: 'Organizace',
  course_timePeriod: 'Časové období',

  otEvent_name: 'Název',
  otEvent_startDate: 'Datum',
  otEvent_dayOfWeek: 'Den',
  otEvent_timeFromTo: 'Čas',
  otEvent_description: 'Popis',
  otEvent_venue: 'Místo konání',
  otEvent_room: 'Místnost',
  otEvent_teacher: 'Vedoucí',
  otEvent_organization: 'Organizace',

  city_name: 'Město',
  city_happeningCount: 'Počet programů',

  happening_occupancy: 'Zaplněnost',

  registration_notes: 'Vaše poznámky k přihlášce',
  registration_informationSourceAnswer: 'Kde jste se dozvěděli o kurzech',
  registration_registrationReasonAnswers: 'Váš důvod zájmu o kurz',
  registration_price: 'Cena přihlášky',
  registration_discounts: 'Slevy',
  registration_premiums: 'Příplatky',
  registration_discountsAndPremiums: 'Slevy a příplatky',
  registration_selectedOtEvent: 'Vybraný program',
  registration_pricingInfo: 'Cena přihlášky',
  registration_paymentTypeConfig: 'Způsob platby',

  registrationReasonAnswer_custom: 'Jiný důvod',
  registrationReasonAnswer_custom_placeholder: 'Uveďte prosím svůj důvod',

  button_select: 'Vybrat',
  button_ok: 'OK',

  breadcrumb_city: 'Výběr města',
  breadcrumb_season: 'Výběr období',
  breadcrumb_course: 'Výběr kurzu',
  breadcrumb_personalData: 'Osobní údaje',
  breadcrumb_startNewRegistration: 'Začít novou registraci',
  breadcrumb_summary: 'Souhrn',

  captcha: 'Ověření proti robotům',
  captcha_invalid: 'Zadaná hodnota ověření nebyla platná',

  organization_paymentNotes: 'Informace k platbě',

  personalData_title: 'Údaje o Vás',
  personalData_info: 'Vaše osobní údaje nebudou zneužity ani nikde publikovány. Potřebujeme je jen pro evidenci osob.',
  personalData_currentAddress: 'Korespodenční adresa',
  personalData_agreeWithPersonalDataProcessing: 'Beru na vědomí informaci o zpracování osobních údajů',
  personalData_personalDataProcessing_required: 'Je potřebné vyjádřit souhlas se zpracováním osobních údajů.',
  personalData_personalDataProcessing_label: 'Zpracování osobních údajů',
  personalData_showAgreement: 'Zobrazit znění',
  personalData_paymentNotes: 'Informace k platbě',
  personalData_agreeWithTermsAndConditions: 'Souhlasím s obchodními podmínkami',
  personalData_termsAndConditionsConsent_required: 'Je potřebné vyjádřit souhlas s obchodními podmínkami.',
  personalData_showTermsAndConditions: 'Zobrazit podmínky',
  personalData_goToSummary: 'Přejít na souhrn',
  personalData_newsSubscriber: 'Přeji si dostávat novinky na email',
  personalData_firstName_placeholder: 'např. Šárka',
  personalData_lastName_placeholder: 'např. Veselá',
  personalData_nameFormat_info: 'Uveďte prosím jména s háčky, čárky, správnou velikostí písmen a bez titulů',
  personalData_address_info: 'Svoji adresu vyplňte v případě, že ji potřebujete na daňovém dokladu (např. pro pojišťovnu)',
  personalData_paymentRedirect_title: 'Přesměrování',
  personalData_paymentRedirect_info: 'Budete přesměrováni na platební bránu {0}',
  personalData_questionsByEmailInfo: 'Máte-li dotazy nebo připomínky, napište nám je prosím na email {0}',

  summary_paymentType: 'Způsob platby',
  summary_paymentType_bank: 'převodem na účet',
  summary_paymentType_trustPay: 'kartou',
  summary_payment_qrCode_desc: 'Tento kód můžete naskenovat pomocí mobilní aplikace vaší banky a ta vám předvyplní platební formulář všema potřebnýma hodnotama.',

  paymentType_bank: 'Převodem na účet',
  paymentType_bank_info: 'Platební údaje vám budou zobrazeny v následujícím kroku a zaslány na váš email, který uvedete níže.',
  paymentType_trustPay: 'Platba kartou Visa, MasterCard',
  paymentType_trustPay_info: 'Po dokončení registrace budete přesměrováni na platební bránu, umožňující platbu kartou.',

  paymentGateway_trustPay: 'TrustPay',

  price_title: 'Cena',
  price_socialDiscount: 'Sleva pro ',
  price_chooseSocialGroup: 'Vyberte prosím svoji skupinu',
  price_validation_chooseSocialGroup: 'Pro uplatnění této slevy je potřebné vybrat skupinu',
  price_lateRegDiscountInfo: 'Z důvodu, že kurz již probíhá, cena byla znížena',
  price_premiums: 'Volby za příplatek',
  price_discounts: 'Slevy',
  price_basicPrice: 'Základní cena',
  price_totalPrice: 'Celková cena',
  price_paymentType_title: 'Způsob platby',
  price_goToPersonInfo: 'Přejít na osobné údaje',
  price_selectPaymentType: 'Vyberte prosím způsob platby',

  finishing_title: 'Dokončení registrace',
  finishing_serverError: 'Nepodařilo se vytvořit vaší registraci z důvodu chyby na serveri. Zkuste to prosím později, nebo nás kontaktujte emailem na adrese {0}. Omlouváme se za komplikaci.',

  success_title: 'Registrace úspěšně dokončena',
  success_thanks: 'Děkujeme za registraci',
  success_emailSent: 'Níže uvedené informace Vám přijdou i emailem na adresu {0}.',
  success_emailSent_spanNotice: 'Kdyby Vám email nepřišel, zkontrolujte si prosím složku s nevyžádanou poštou.',
  success_emailSendingError: 'Při odesílání potvrzujícího emailu (na {0}) s níže uvedenými informacemi nastala chyba, ale Vaše přihláška je platná. Zapište si prosím  zde uvedené platební informace.',

  error_title: 'Chyba aplikace',
  error_generic_desc: 'Při komunikaci se serverem nastala chyba. Zkuste prosím operaci znovu, nebo nás kontaktujte emailem na adrese {0}. Omlouváme se za vzniklé potíže.',
  error_goTo: 'Přejít na',
  error_homepage: 'úvodní stránku',

  registration_error_creatingPerson: 'Chyba při vytváření záznamu o osobě.',
  registration_error_updatingPerson: 'Chyba při aktualizaci záznamu o osobě.',
  registration_error_saving: 'Chyba při ukládání přihlášky do databáze.',
  registration_error_creating: 'Chyba při vytváření přihlášky.',
  registration_error_precedingRegNotFound: 'Pokud jste navštěvovali kurz v předcházejícím období, kontaktujte nás prosím emailem na adrese {0}.',
  registration_onlyPrecedingSeasonParticipants: 'Na toto cvičební období se mohou přihlašovat zatím jen účastníci kurzů předcházejícího cvičebního období "{0}", aby měli možnost navštěvovat navazující kurz. Ostatní zájemci budou mít možnost se přihlásit později. Děkujeme za pochopení.',
  registration_followUpOnly: 'Přihlašování je povoleno jen pro cvičence běžících kurzů.',
  registration_change: 'změnit',
  registration_informationSource_customText: 'jiný zdroj (možnost zadat ručně)',
  registration_informationSource_customText_placeholder: 'Uveďte prosím zdroj',

  summary_title: 'Souhrn',
  summary_registration_number: 'Číslo přihlášky',
  summary_registration_price: 'Cena přihlášky',
  summary_registration_basicPrice: 'Základní cena kurzu',

  summary_payment: 'Platební informace',
  summary_payment_bank_deadline: 'Platbu je nutné provést do data uvedeného v registračním mailu, který vám byl zaslán, jinak bude vaše registrace neplatná.',
  summary_payment_bank_sendTo: 'Platbu za kurz převeďte prosím na účet:',
  summary_payment_bank_bankName: 'Název banky',
  summary_payment_bank_accountNumber: 'Číslo účtu',
  summary_payment_bank_iban: 'IBAN',
  summary_payment_bank_variableSymbol: 'Variabilní symbol',
  summary_payment_bank_specificSymbol: 'Specifický symbol',
  summary_payment_notes: 'Poznámky k platbě',
  summary_successfullyPayed: 'Vaše přihláška byla úspěšně zaplacena.',

  summary_selectedCourse: 'Zvolený kurz',

  result_error_title: 'Chyba při vykonávání platby',
  result_error_info: 'Počas platby sa vyskytla chyba. Môžete to skúsiť znovu alebo zmeniť typ platby  alebo přihlášku stornovat.',

  result_cancel_title: 'Plaba za přihlášku byla stornována',
  result_cancel_info: 'Ak ste stornovali platbu kvôli nevyhovujúcemu spôsobu platby, môžete ho zmeniť nižšie.',

  result_repeatPayment_title: 'Opakování pokusu o platbu',
  result_repeatPayment_info: 'Nastala-li na platební bráně technická chyba, je pravděpodobné, že bude opravena v krátkém čase. Můžete zkusit vykonat platbu znovu například za půl hodiny.',
  result_repeatPayment_button: 'Zkusit platbu znovu',
  result_changePaymentType_title: 'Změna způsobu platby za přihlášku',
  result_registration_title: 'Vaše přihláška',

  result_changePaymentType_button_offline: 'Změnit typ platby',
  result_changePaymentType_button_online: 'Zaplatit vybraným způsobem',
  result_changePaymentType_selectType: 'Vyberte prosím nový typ platby',

  result_cancelRegistration_title: 'Stornování přihlášky',
  result_cancelRegistration_info: 'Jestli jste se rozhodli přihlášku nezaplatit, stornujte ji prosím.',
  result_cancelRegistration_button: 'Stornovanat přihlášku',
  result_cancelRegistration_success: 'Vaše přihláška č. {0} byla stornována.',

  termsAndConditions_title: 'Všeobecné obchodní podmínky',
  termsAndConditions_info: 'Všeobecné obchodní podmínky organizace {0} pro poskytování kurzů jógy.',

  organizationPage_title: 'Informace o organizaci',
  organizationPage_basicInfo: 'Základní informace',
  organizationPage_places: 'Místa působnosti',

  organization_name: 'Název',
  organization_address: 'Adresa',
  organization_telephone: 'Telefon',
  organization_email: 'Email',
  organization_termsAndConditions: 'Obchodní podmínky',

  summary_orderButton: 'Závazně objednat',
  summary_onlinePaymentInfo: 'Po odeslání objednávky budete přesměrovani na platobní bránu.',
  summary_submitBlock_title: 'Odeslání objednávky',
  summary_afterRegistrationInfo: 'Doplňující informace organizace'
};
